import React from 'react';
import RequestLicenseTask from '../ManageCenter/RequestLicenseTask';
import PowerAppChangeTask from '../ManageCenter/PowerAppChangeTask';

const PowerAppTasks = ({app, refresh}) => {

    // const [isLoading, setIsLoading] = useState(true);
    // const [requestLicenseTasks, setRequestLicenseTasks] = useState(app.requestLicenseTasks);
    // const cancelSource = useRef(null);

    // useEffect(() => {
    //     return downloadData();
    // }, []);

    // const downloadData = () => {
    //    refresh();
    //    return getRequestLicenseTasks();
    // }

    // const getRequestLicenseTasks = () => {
    //     setIsLoading(true);

    //     if (cancelSource.current) {
    //         cancelSource.current.cancel();
    //     }
        
    //     cancelSource.current = cancelToken.source();

    //     let url = `/RequestLicenseTasks?powerAppId=${app.id}&status=1`;
    
    //     Api.get(url, {
    //         cancelToken: cancelSource.current.token})
    //     .then(res => res.data)
    //     .then(tasks => {
    //         setIsLoading(false);
    //         setRequestLicenseTasks(tasks);
    //     })
    //     .catch(error => {
    //         console.log(error);
    //     });

    //     return () => {
    //         cancelSource.current.cancel();
    //     }
    // }


    const requestLicenseTasks = app.requestLicenseTasks.map(x => 
        <div style={styles.taskDivStyle} key={x.id}>
            <RequestLicenseTask
                task = {x}
                //refresh = {downloadData}
            />
        </div>
    )

    const powerAppChangeTasks = app.changeTasks.map(t =>
        <div style={styles.taskDivStyle} key={t.id}>
            <PowerAppChangeTask
                change={t}
                refresh={refresh}
                created={t.requestDate}
            />
        </div>
    )

    const tasks = [...requestLicenseTasks, ...powerAppChangeTasks]

    return (
            <div style={{ padding: '20px 20px 20px 20px', maxWidth: "680px", minWidth: "380px"}}>
                <div style={{ display: "flex", flexWrap: "wrap", marginLeft: "20px" }}>
                    {tasks}
                </div>
            </div>
    )
}

const styles = {
    taskDivStyle: {
        flex: "1",
        width: "50%",
        display: "flex",
        justifyContent: "center"
    }
}
export default PowerAppTasks;


// WEBPACK FOOTER //
// ./src/components/EditSite/PowerAppTasks.js